
/*eslint-disable*/
import React from "react";
// react library for routing
// reactstrap components
import {Button, Card, CardBody, CardHeader, Col, Container, Form, Modal, Nav, NavItem, NavLink, Row} from 'reactstrap';
// core components
import NotificationAlert from "react-notification-alert";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import AppNavBar from "./AppNavBar";
import ReviewForm from "./pages/reviews/ReviewForm";
import auditService from "../services/auditService.js";
import AuditForm from "./pages/audit/AuditForm";
import AdminService from "../services/adminService";
import Loader from "./Loader";
import AdminForm from "./pages/admin/Form";
import SignupForm from "./SignupForm";

class Signup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            adminRole: "ROLE_FREE",
            selectKey: UtilService.uuidv4(),
            loginModal: false,
            errorData: {},
            file:null,
            middleName:'',
            userCompanyName:'',
            fileSelectUUID:UtilService.uuidv4(),
            loading:false,
            reviewsSearchEnabled:false
        };
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
    }

    handleChange = (event) => {
        if(event.target.type === "checkbox") {
            this.setState({[event.target.name]: event.target.checked});
        } else{
            this.setState({[event.target.name]: event.target.value});
        }
    }

    handleSubmit = (event)  => {
        event.preventDefault();
        if(this.state.userCompanyName === ''){
            this.notify(
                "danger",
                "ERROR",
                "Company Name is required!"
            )
            return;
        }
        this.setState({loading: true})
        const data = new FormData()
        data.append('file', this.state.file)
        data.append('adminRole', this.state?.adminRole)
        data.append('emailAddress', this.state?.emailAddress)
        data.append('firstName', this.state?.firstName)
        data.append('middleName', this.state?.middleName)
        data.append('lastName', this.state?.lastName)
        data.append('userCompanyName', this.state?.userCompanyName)
        data.append('reviewsSearchEnabled', this.state?.reviewsSearchEnabled)
        AdminService.signup(data).then((response) => {
            if (response.responseStatus === "SUCCESS") {
                this.notify(
                    "success",
                    "Account Created Successfully",
                    "Your free account has been created successfully! Please check your email for further instructions!"
                )
                setTimeout(() => {
                    this.props.history.push("/");
                }, 3000);

            } else {
                this.setState({ errorData: response.data });
            }
            this.setState({loading: false})
        });
    }

    fileChange = (event) => {
        this.setState({file: event.target.files[0]})
    };



    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };


    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    onChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    render() {
        return (
            <div style={{backgroundColor: "white"}}>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <AppNavBar loginModalToggle={this.toggleModal}/>

                {/* Hero Banner */}
                <div className="hero-banner" style={{height:"256px"}}>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>Sign Up</p>
                                    <h1 style={{textAlign: "start"}}>Become a free User</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <br/>
                <br/>
                <br/>

                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        {this.state.loading && <Loader />}
                        <CardBody>
                            <Row>

                                <Col md={4}></Col>
                                <Col md={4}>
                                    <CardHeader>
                                        <h3 className="mb-0">Create Free Account</h3>
                                    </CardHeader>
                                </Col>
                                <Col md={4}></Col>
                            </Row>
                            <Row>
                                <Col md={4}></Col>
                                <Col md={4}>
                                    <Form role="form" onSubmit={this.handleSubmit}>
                                        <SignupForm
                                            onChange={this.handleChange}
                                            valueObj={this.state}
                                            errorObj={this.state.errorData}
                                            isEdit={false}
                                            fileChange = {this.fileChange}
                                            fileSelectUuid = {this.state.fileSelectUUID}
                                        />
                                        <div className="text-center">
                                            <Button className="my-4" color="default" outline type="submit">
                                                Submit
                                            </Button>
                                        </div>
                                    </Form>
                                </Col>
                                <Col md={4}></Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Container>



                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>

                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                            onClick={(event) => {
                                                this.props.history.push("/aboutUs")
                                            }}
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        );
    }
}

export default Signup;
